<template>
  <van-popup
    v-model:show="visible"
    class="ob-popup"
    ref="popupRef"
    :position="!isWeb ? position : 'bottom'"
    :overlay="overlay"
    :z-index="zIndex"
    :round="!isWeb ? round : true"
    :teleport="teleport"
    :lazy-render="lazyRender"
    :close-on-popstate="true"
    @close="onClose"
    @opened="afterOpen"
  >
    <div 
      class="ob-popup-content" 
      :style="{
        ...bodyPadding,
        height: height,
        backgroundColor: contentBackgroundColor || ''
      }"
    >
      <slot name="nav" v-if="navbar">
        <div class="nav-bar">
          <SvgIcon :name="leftIcon" @click="onClose" v-if="leftIcon"/>
          <p :class="titlePlacement">{{ title }}</p>
        </div>
      </slot>
      <template v-if="navigation && headVisible && !isWeb">
        <Notice :showNotice="false"/>
        <BackNav :title="title" :leftCallBack="onClose" :iconColor="navColor" :backgroundColor="navbarColor" top="var(--orbit-status-bar-height)">
          <template #right>
            <slot name="rightIcon"></slot>
          </template>
        </BackNav>
      </template>
      
      <slot></slot>
    </div>
  </van-popup>
</template>

<script setup>

import { useSystemStore } from '@/stores/system'
import { storeToRefs } from 'pinia';

const route = useRoute()
const systemStore = useSystemStore()
const { isWeb } = storeToRefs(systemStore)

const emits = defineEmits(['onBack', 'close', 'opened', 'update:modelValue'])
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  overlay: {
    type: Boolean,
    default: true,
  },
  round: {
    type: Boolean,
    default: false,
  },
  navigation: {
    type: Boolean,
    default: false
  },
  navbar: {
    type: Boolean,
    default: false
  },
  lazyRender: {
    type: Boolean,
    default: true
  },
  zIndex: {
    type: [String, Number],
  },
  title: {
    type: String,
    defualt: ''
  },
  height: {
    type: String,
    default: 'calc(100vh - var(--browser-address-bar, 0px))'
  },
  navColor: {
    type: String
  },
  navbarColor: {
    type: String
  },
  contentBackgroundColor: {
    type: String,
  },
  position: {
    type: String,
    default: 'bottom'
  },
  leftIcon: {
    type: String,
    default: ''
  },
  titlePlacement: {
    type: String,
    default: 'center'
  },
  teleport: {
    type: String,
    default: 'body'
  },
  leftIconCallBack: {
    type: Function,
    default: null
  }
})

const popupRef = ref(null)

const visible = ref(false)
const headVisible = ref(false)
const bodyPadding = ref({})

// const contentHeight = computed(() => {
//   if (props.height) {
//     return props.height
//   }
//   // return props.navigation ? `calc(100vh - var(--orbit-nav-height, 0px) - var(--orbit-status-bar-height, 0px))` : '100vh'
//   return '100vh'
// })


function onClose () {
  visible.value = false
  emits('onBack')
  emits('close')
  emits('update:modelValue', visible.value)
  setTimeout(() => {
    headVisible.value = false
  }, 500);
}

function afterOpen () {
  emits('opened')
}

watch(() => props.modelValue, (val) => {
  visible.value = val
  if (val) {
    headVisible.value = true
  }
}, {
  immediate: true
})

watch(route, (val) => {
  if (visible.value) {
    onClose()
  }
}, {
  immediate: true,
  deep: true
})

onMounted(async () => {
  setTimeout(() => {
    bodyPadding.value = {
      '--body-padding-top': document.body.style.getPropertyValue('padding-top')
    }
  }, 500)
})

defineExpose({
  visible,
  popupRef
})
</script>

<style lang="postcss" scoped>
.ob-popup-content {
  position: relative;
  width: 100vw;
  overflow: auto;
}

.nav-bar {
  position: sticky;
  top: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px 20px 16px;
  box-sizing: border-box;
  background-color: var(--background-selection);
  z-index: 99;
  p {
    width: 100%;
    font-size: 18px;
    font-family: orbit-M;
    box-sizing: border-box;
  }
  .left {
    text-align: left;
    padding-left: 39px;
  }
  .center {
    text-align: center;
  }
  .svg-icon {
    position: absolute;
    left: 20px;
    height: 48px;
  }
}

/* transition内置组件 渐出样式 */
.obslide-enter-active, .obslide-leave-active {
  transition: transform 0.3s ease-out;
}
.obslide-enter-from, .obslide-leave-to {
  transform: translateX(100%);
}
.obslide-enter-to, .obslide-leave-from {
  transform: translateX(0);
}
</style>
